import { Capacitor, registerPlugin } from '@capacitor/core'

export type AudioOutputDeviceType =
  | 'airplay'
  | 'auxiliary_line'
  | 'bluetooth_a2dp'
  | 'bluetooth_le'
  | 'bluetooth_sco'
  | 'built_in_receiver'
  | 'built_in_speaker'
  | 'bus'
  | 'car_audio'
  | 'display_port'
  | 'dock'
  | 'hearing_aid'
  | 'hdmi'
  | 'ip'
  | 'line_out'
  | 'remote_submix'
  | 'telephony'
  | 'unknown'
  | 'usb'
  | 'virtual'
  | 'wired_headphones'
  | 'wired_headset'

export interface AudioOutputDevice {
  type: AudioOutputDeviceType
  name?: string
}

interface AudioOutputDeviceDetectionPlugin {
  getAudioOutputDevice(): Promise<Partial<AudioOutputDevice>>
}

const bridge = registerPlugin<AudioOutputDeviceDetectionPlugin>(
  'AudioOutputDeviceDetection',
)

export const audioOutputDeviceDetection = {
  async getDevice(): Promise<AudioOutputDevice | null> {
    if (
      !Capacitor.isNativePlatform() ||
      !Capacitor.isPluginAvailable('AudioOutputDeviceDetection')
    ) {
      return null
    }

    const device = await bridge.getAudioOutputDevice()
    return device.type ? (device as AudioOutputDevice) : null
  },
}
